//this closure ensures we won't be interfering with other libraries that have defined $
(function($) {
	'use strict';

	var profilesTable;
	var $profilesTable;
	var downloadButtonEl;
	var teamProfilesPageURL = './jsp/teamProfiles/teamProfiles.jsp';
	var JSRegex = /<\s*script\s*>.*<\s*\/script\s*>/gi;
	
	var getSelectedProfiles = function() {
		return $profilesTable.DataTable().rows('.row_selected').data();
	};
	
	var deleteProfiles = function() {
	
		$.displayLoadingIndicator(deletingText);
		
		var profilesData = getSelectedProfiles();
		var deleteRequestArray = [];
		var selectedProfiles = getSelectedProfiles();
		
		$.each(selectedProfiles, function(index, value) {
			var deleteRequest = $.ajax({
				url: 'ws/topaz/teams/profiles/' + this.id,
				method: "DELETE"
			});
			
			deleteRequestArray.push(deleteRequest);
		});
		
		$.when.apply(
			$, 
			deleteRequestArray
		).done(function () {
			$.showSuccessStatus(deleteSuccessText);
			$profilesTable.DataTable().rows('.row_selected').remove();
			profilesTable.draw();
			updateDownloadButtonState();
		}).fail(function (error) {
			$.showErrorStatus(deleteFailText + ' ' + error.responseJSON.description);
		}).always(function () {
			$.removeLoadingIndicator();
		});
	};

	var initializeProfilesTable = function() {
		var tableID = '#teamProfilesTable';
        var columns = [
                {
                    data : 'name',                   
                    defaultContent : '',
                    render : function(data, type, row) {
                    	var encodedProfileId = encodeURI(row.id);
                    	//Scrub out any script tags to prevent script injection
                    	return '<a href="jsp/teamProfiles/details.jsp?profile=' + encodedProfileId + '">' + data.replace(JSRegex, '') + '</a>';
                    }
                },
                {
                    data : 'lastModified',                   
                    defaultContent : ''
                },
                {
                    data : 'downloads',                   
                    defaultContent : ''
                },
                {
                	data : 'id',
                	defaultContent : '',
                	visible: false
                }
		];
		
		var headers = [
        	{
        		title: descriptionHeader
        	},
        	{
        		title: lastChangedHeader
        	},
        	{
        		title: downloadsHeader
        	}
        ];
		
		//We only display the groups column if security is on
		if(securityEnabled) {
			columns.splice(1, 0, {
				data : 'groups',                   
                defaultContent : ''
			});
			headers.splice(1, 0, {
				title: groupsHeader
			});
		}
        
        var options = $.defaultTableOptions();
        options.columns = columns;
        options.rowCountID = '#profilesRowCount';
        options.paginationID = '#profilesPagination';
        options.filterID = '#profilesFilter';
        options.filterInputID = '#profilesFilterInput';
        options.colReorder = true;
        
        var tableControls = null;
        
        if(userHasTeamProfileRole) {
        	tableControls = {
	        	deleteButton: {
	        		deleteConfirmationCallback : deleteProfiles,
	        		disabled : "disabled",
	        		enablement : 'multi'
	        	}
		    };
        }
        
        var tableOptions = {
        	toolbarContainerId : 'profilesToolbar'
        };
        
        profilesTable = new SimpleTableComponent('profiles', '#profilesTableContainer', headers, tableOptions).createTable(options, 'multi', null, null, tableControls);
        $profilesTable = $('#profilesTable');
	};
	
	var updateDownloadButtonState = function() {
		var numRowsSelected = document.querySelectorAll('.row_selected').length;
		var tableIsEmpty = document.querySelector('.dataTables_empty') !== null;
		
		if (numRowsSelected !== 1 || tableIsEmpty) {
			downloadButtonEl.setAttribute('disabled', 'disabled');
		} else {
			downloadButtonEl.removeAttribute('disabled');
		}
	};
	
	var getProfiles = function() {
		
		return $.get({
				url:'ws/topaz/teams/profiles',
				cache : false
			}).done(function(data) {
				profilesTable.clear();
				
				if(!!data.teamProfiles) {
					$.each(data.teamProfiles, function() {
						//Convert the groups array into a string
						
						if (!!this.groups) {
			                var groupNames = this.groups.map(function(item) {
			                    return item.name;
			                });
			                
			                groupNames.sort();
			                
			                this.groups = groupNames.join(', ');
			            } else {
			                this.groups = noGroupText;
			            }
			            
			            this.lastModified = new Date(this.lastModified);
					});
					
	        		profilesTable.rows.add(data.teamProfiles);
				}
				
        		profilesTable.draw();
			}).fail(function (request) {
				$.showErrorStatus(loadingUserInfoFailText + ' ' + request.responseJSON.description);
			}).always(function () {
				$.removeLoadingIndicator();
			});
	};
	
	var downloadProfile = function() {
		var selectedProfiles = getSelectedProfiles();
		var url = 'ws/topaz/teams/profiles/' + selectedProfiles[0].id;
		
		$.displayLoadingIndicator(downloadingProfileText);
	    
	    $.when(
	    	downloadZip(url, 'teamProfile.zip')
	    ).done(function() {
    		selectedProfiles[0].downloads += 1;
    		profilesTable.rows('.row_selected').invalidate().draw();
    	}).fail(function(status, statusText) {
			$.showErrorStatus(downloadingProfileFailText + ' ' + selectedProfiles[0].name);
		}).always(function() {
			$.removeLoadingIndicator();
		});
	};
    
    $(document).ready(function() {
    
    	downloadButtonEl = document.getElementById('profilesDownloadButton');
		downloadButtonEl.onclick = downloadProfile;
		//If the download button is enabled when the user refreshes, it is enabled on page load in Firefox
		//This is a known Firefox bug, so we disable the button here
		downloadButtonEl.setAttribute('disabled', 'disabled');
		
		initializeProfilesTable();
		document.getElementById('profilesTable').onclick = updateDownloadButtonState;
        
        document.addEventListener('click', function(event) {
        	if (!$(event.target).hasClass('status-text')) {
                $.clearStatus();
            }
        });
        
        //Check if we've been redirected from the details page with a status message to display
        var teamProfileDetailsMessage = JSON.parse(sessionStorage.getItem('teamProfileDetailsMessage'));
        
        if(!!teamProfileDetailsMessage) {
        	if(teamProfileDetailsMessage.error) {
        		$.showErrorStatus(teamProfileDetailsMessage.message);
        	} else {
        		$.showSuccessStatus(teamProfileDetailsMessage.message);
        	}
        	
        	sessionStorage.removeItem('teamProfileDetailsMessage');
		}
		
		$.displayLoadingIndicator(loadingText);
        
        $.when(
        	getProfiles()
        ).always(function() {
        	$.removeLoadingIndicator();
        });
    });
})(jQuery);